import moment from 'moment';
export const getCurrentTimestamp = () => {
    return moment().utcOffset(2, true).add(2, 'hour').unix();
}